import React, { useState } from "react";
import styles from "../css/styles.module.css";

export default function Password(props) {
  const [input, setInput] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [message, setMessage] = useState({
    message: "",
    error: true
  });
  const [showError, setShowError] = useState(null);

  function handleOnSubmit(e) {
    e.preventDefault();
    setShowError(true);
    if (input.newPassword === input.confirmPassword) {
      props.user.userData
        .updatePassword(input.newPassword)
        .then(() => {
          setMessage({
            message: "Password updated successfully",
            error: false
          });
        })
        .catch((err) => {
          console.log(err.message);
          setMessage({
            message: err.message,
            error: true
          });
        });
    } else {
      setMessage({
        message: "Password did not match",
        error: true
      });
    }
  }

  function handleOnChange(e) {
    setInput({
      ...input,
      [e.target.name]: e.target.value,
    });
  }

  return (
    <div className={styles.content}>
      <div className={styles.form}>
        <form onSubmit={handleOnSubmit}>
          <h1>Change password</h1>
          <br />
          <input
            name="newPassword"
            type="password"
            placeholder="New password"
            value={input.newPassword}
            onChange={handleOnChange}
            required
          />
          <input
            name="confirmPassword"
            type="password"
            placeholder="Confirm new password"
            value={input.confirmPassword}
            onChange={handleOnChange}
            required
          />
          <button type="submit">Change password</button>
          {showError && <p className={message.error ? styles.error : styles.success}>{message.message}</p>}
        </form>
      </div>
    </div>
  );
}
